import { CalendarEventDetails, PlayerAccount, Post, PostDeliveryStatus } from "@/interfaces";
import * as React from "react";
import { useState } from "react";
import { Header, Icon, Table } from "semantic-ui-react";

import { formatDate, getUrlForPlayer, wrapInLinkIfHrefIsPresent } from "./utils";
import { useSocialCoachSession } from "@/utils";

type Props = {
  isLoading: boolean;
  eventDetails: CalendarEventDetails | undefined;
};

export const PushTable: React.FC<Props> = ({ eventDetails }) => {
  const { session } = useSocialCoachSession();
  const [showNotifications, setShowNotifications] = useState(true);

  const playerMap =
    eventDetails?.players.reduce((map, player) => {
      if (player.playerId) map[player.playerId] = player;
      return map;
    }, {} as { [key: number]: PlayerAccount }) || {};

  const pushRecords = eventDetails?.posts?.filter(p => p.deliveryStatus != "IGNORE") || [];
  const deliveredCount = pushRecords.filter(p => p.deliveryStatus == "DELIVERED").length;

  const getStatusLabel = (post: Post) => {
    switch (post.deliveryStatus) {
      case PostDeliveryStatus.PENDING_PUSH:
        return "Pending";
      case PostDeliveryStatus.FAILED_PUSH:
        return "Unable to deliver";
      case PostDeliveryStatus.IGNORE:
        return "Skipped";
      case PostDeliveryStatus.DELIVERED:
        return `Delivered ${formatDate(post.deliveryDatetimeUtc)}`;
      default:
        return "";
    }
  };

  return pushRecords.length === 0 ? null : (
    <>
      <Header className="postsHeader">
        Push Notifications
        <a className="showHideNotifications" onClick={() => setShowNotifications(!showNotifications)}>
          <Icon name={`chevron ${showNotifications ? "up" : "down"}`} />
        </a>
      </Header>
      <Table className="postsTable" compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Player</Table.HeaderCell>
            <Table.HeaderCell>Notification Status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {showNotifications &&
            pushRecords.map(post => {
              const player = playerMap[post.playerId];
              return (
                <Table.Row key={`push-row-${post.postId}`}>
                  <Table.Cell>
                    {wrapInLinkIfHrefIsPresent(
                      getUrlForPlayer(session, player.playerId),
                      <>
                        <div className="boldText">{player.email}</div>
                        <div>
                          {player.firstName} {player.lastName}
                        </div>
                      </>
                    )}
                  </Table.Cell>
                  <Table.Cell>{getStatusLabel(post)}</Table.Cell>
                </Table.Row>
              );
            })}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell>{pushRecords.length} Total</Table.HeaderCell>
            <Table.HeaderCell>{deliveredCount} Delivered</Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </>
  );
};
